// Map #1 — Canyon Meadow (the original arena): sunlit grassland ringed by canyon cliffs, rolling hills, painted trees and
// bushes, sandstone boulders and spires. Everything breaks and the grass burns. Same seed → same layout as before the map
// system (CLASSIC_TERRAIN is the old generator's numbers; tests/maps.test.ts pins a fingerprint).
import type { MapCoreDef } from '../../core/mapdef';
import { CLASSIC_TERRAIN } from '../../core/terrain';

export const MAP: MapCoreDef = {
  id: 'canyon-meadow',
  name: 'Canyon Meadow',
  tagline: 'Sunlit grassland ringed by canyon cliffs. Trees, boulders and rock spires break apart in the fighting.',
  order: 1,
  status: 'ready',
  time: { default: 'day', day: 'noon' },
  unlock: {},
  terrain: CLASSIC_TERRAIN,
  fire: true,
  boss: { name: 'HOLLOW TYRANT' },
  // no hazards: map #1 plays exactly as it always has
};
